import React, { memo } from "react";
import TextField from "@mui/material/TextField";
import { RegisterInputData, RegistrationFieldReferences } from "./PublicRegister";
import TermsAndConditions from "./TermsAndConditions";
import InputErrorMessage from "@mirage/components/inputErrorMessage/InputErrorMessage";
import AddressAutocomplete, { ISelectedAddressRecord } from "@mirage/components/addressBox/AddressAutocomplete";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import { PPConstants } from "@shared/publicportal/constants";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

interface ThirdStepFieldsProps {
    mobilePhoneData: RegisterInputData;
    addressData: RegisterInputData;
    termsData: { checked: boolean; showError: boolean };
    termsOnChange: () => void;
    onChangeHandler: (value: string, inputReference: RegistrationFieldReferences) => void;
    addressBoxHandler: (address: ISelectedAddressRecord) => void;
    onBlurHandler: (inputReference: RegistrationFieldReferences) => void;
}

const ThirdStepFields: React.FC<ThirdStepFieldsProps> = memo((props): JSX.Element => {
    const { mobilePhoneData, addressData, termsData, termsOnChange, addressBoxHandler, onChangeHandler, onBlurHandler } = { ...props };
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const { clientSettings } = sessionValue;
    const { isMobile } = useDeviceDetect();
    const fieldWidth = isMobile ? "100%" : "60%";

    return (
        <>
            <TextField
                sx={{ width: fieldWidth }}
                required={true}
                id="register-mobilePhone"
                error={!mobilePhoneData.validationResult.passed}
                value={mobilePhoneData.value}
                helperText={<InputErrorMessage passed={mobilePhoneData.validationResult.passed} message={mobilePhoneData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "mobilePhone")}
                onBlur={() => onBlurHandler("mobilePhone")}
                label="Mobile Phone Number"
                variant="outlined"
            />
            <AddressAutocomplete
                gazetteer="national"
                className="registration-form-addressAutocomplete"
                onSelect={addressBoxHandler}
                localGazetteerUrl={clientSettings?.LOCAL_GAZETTEER_URL as string}
                localGazetteerToken={clientSettings?.LOCAL_GAZETTEER_TOKEN as string}
                nationalGazetteerUrl={clientSettings?.NATIONAL_GAZETTEER_URL as string}
                nationalGazetteerToken={clientSettings?.NATIONAL_GAZETTEER_TOKEN as string}
            />
            <TextField
                sx={{ width: fieldWidth }}
                required={true}
                id="register-address"
                error={!addressData.validationResult.passed}
                value={addressData.value}
                helperText={<InputErrorMessage passed={addressData.validationResult.passed} message={addressData.validationResult.error} />}
                onChange={(e) => onChangeHandler(e.target.value, "address")}
                onBlur={() => onBlurHandler("address")}
                label="Address"
                variant="outlined"
            />
            <TermsAndConditions termsData={termsData} termsOnChange={termsOnChange} />
        </>
    );
});

export default ThirdStepFields;
